import { render } from "./SupplierDetail.vue?vue&type=template&id=c9414400&scoped=true"
import script from "./SupplierDetail.vue?vue&type=script&lang=js"
export * from "./SupplierDetail.vue?vue&type=script&lang=js"

import "./SupplierDetail.vue?vue&type=style&index=0&id=c9414400&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9414400"]])

export default __exports__